"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SumerTimelockController__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "minDelay",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "proposers",
                type: "address[]",
            },
            {
                internalType: "address[]",
                name: "executors",
                type: "address[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "CallExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "delay",
                type: "uint256",
            },
        ],
        name: "CallScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "Cancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldDuration",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newDuration",
                type: "uint256",
            },
        ],
        name: "MinDelayChange",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        inputs: [],
        name: "CANCELLER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "EXECUTOR_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PROPOSER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "TIMELOCK_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "payload",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "payloads",
                type: "bytes[]",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "executeBatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "getMinDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "duration",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "getTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "hashOperation",
        outputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "payloads",
                type: "bytes[]",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
        ],
        name: "hashOperationBatch",
        outputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "isOperation",
        outputs: [
            {
                internalType: "bool",
                name: "registered",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "isOperationDone",
        outputs: [
            {
                internalType: "bool",
                name: "done",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "isOperationPending",
        outputs: [
            {
                internalType: "bool",
                name: "pending",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "id",
                type: "bytes32",
            },
        ],
        name: "isOperationReady",
        outputs: [
            {
                internalType: "bool",
                name: "ready",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "delay",
                type: "uint256",
            },
        ],
        name: "schedule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "bytes[]",
                name: "payloads",
                type: "bytes[]",
            },
            {
                internalType: "bytes32",
                name: "predecessor",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "salt",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "delay",
                type: "uint256",
            },
        ],
        name: "scheduleBatch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newDelay",
                type: "uint256",
            },
        ],
        name: "updateDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SumerTimelockController__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(minDelay, proposers, executors, overrides) {
        return super.getDeployTransaction(minDelay, proposers, executors, overrides || {});
    }
    deploy(minDelay, proposers, executors, overrides) {
        return super.deploy(minDelay, proposers, executors, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.SumerTimelockController__factory = SumerTimelockController__factory;
SumerTimelockController__factory.bytecode = _bytecode;
SumerTimelockController__factory.abi = _abi;
//# sourceMappingURL=SumerTimelockController__factory.js.map